import ScreenContainer from "../components/screen";
import { useLanguage } from "../config/language/LanguageContext";

export default function PrivacyPolicy() {
  const { locale } = useLanguage();

  return (
    <ScreenContainer>
      <section id="privacy-policy" className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-3xl font-semibold text-gray-800 text-center mb-8">
            {locale.PRIVACY_POLICY?.title || "Privacy Policy"}
          </h2>
          
          <div className="text-gray-600 text-base leading-relaxed">
            {locale.PRIVACY_POLICY?.lastUpdated && (
              <p className="mb-8 text-center text-gray-500 italic">
                {locale.PRIVACY_POLICY.lastUpdated}
              </p>
            )}
            <div dangerouslySetInnerHTML={{ __html: locale.PRIVACY_POLICY?.content || "<p>Content coming soon...</p>" }} />
          </div>
        </div>
      </section>
    </ScreenContainer>
  );
}
